import React, { useEffect, useRef, useState } from "react";

function CounterSection() {
    const sectionRef = useRef(null);

    const [startCount, setStartCount] = useState(false);

    const [cards, setCards] = useState(0);
    const [visits, setVisits] = useState(0);
    const [rating, setRating] = useState(0);

    // Start animation on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartCount(true);
                }
            },
            { threshold: 0.4 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    // Counter animation
    useEffect(() => {
        if (!startCount) return;

        let count1 = 0;
        let count2 = 0;
        let count3 = 0;

        const interval = setInterval(() => {
            // 89k
            if (count1 < 89) {
                count1++;
                setCards(count1);
            }

            // 76%
            if (count2 < 76) {
                count2++;
                setVisits(count2);
            }

            // 4.93
            if (count3 < 4.93) {
                count3 += 0.05;
                setRating(count3.toFixed(2));
            }

            if (count1 >= 89 && count2 >= 76 && count3 >= 4.93) {
                clearInterval(interval);
            }
        }, 30);

        return () => clearInterval(interval);
    }, [startCount]);

    return (
        <section className="counter-section" ref={sectionRef} >
            <div className="container">
                <div className="counter-boxes">
                    <div className="counter-box" >
                        <h1>{cards}k </h1>
                        <p p > Cards created today </p>
                    </div>

                    < div className="counter-box" >
                        <h1>{visits} % </h1>
                        <p>Repeat customer visits</p>
                    </div>

                    <div className="counter-box" >
                        <h1>{rating} </h1>
                        <p>Average satisfaction</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CounterSection;